import React, {useState} from "react";
import "./SimilarStocks.scss";import StockChart from "../StockChart";
import OwlCarousel from "react-owl-carousel2";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";
import {withRouter} from "react-router-dom";
import {Redirect} from "react-router-dom";
import SparklineGraph from "../StockGraph/SparklineGraph";

const ProfileIcon = assetUrl+"images/profile-icon.svg";

function SimilarStocks(props){
	// const [stockId, setStockId] = useState("");
	let options = {
        items: props.stock_list.length > 1 ? 2:1,
        dots: false,
        rewind: true,
        autoplay: false,
        stagePadding: 1
    };
    const {stock_list,setStockId,stock_history_details} = props;

    const stockRedirectHandler = (stock_id) =>{
    	setStockId(stock_id)
	    return props.history.push("/stock-detail/" + stock_id)
    }


    return(
        <div className={"similar-stock-component"}>
            {
                stock_list.length > 0 ?
                <OwlCarousel options={options}>
                    {
                        stock_list.map((item,index)=>{
                            let xaxis = [];
                            let yaxis = [];
                            let graphData = item.node.stockhistory?item.node.stockhistory.edges:[];
	                        if (graphData.length === 1) {
		                        // let temp_xAxis = [graphData[0].node.updatedPrice]
		                        // xaxis = temp_xAxis.flatMap(i=>[i,i,i,i,i])
		                        // let temp_yAxis = [graphData[0].node.created]
		                        // yaxis = temp_yAxis.flatMap(i=>[i,i,i,i,i])
                                // var nowHour = new Date(graphData[0].node.created).getHours();
                                // for(var i = 0; i < nowHour ; i++){
                                //     let date = new Date(new Date(graphData[0].node.created).getTime() - (1000*60*(60*i)));
                                //     xaxis.push(date.toISOString());
                                //     yaxis.push(graphData[0].node.marketCurrentTotal);
                                // }
                                var nowHour = new Date(graphData[0].node.created).getHours();
                                var startDate = new Date(graphData[0].node.created);
                                startDate.setDate(startDate.getDate() - 1);
                                for (var i = 0; i < nowHour; i++) {
                                    let date = new Date(new Date(graphData[0].node.created).getTime() - (1000 * 60 * (60 * i)));
                                    if (date.getDate() > startDate.getDate()) {
                                        xaxis.push(date);
                                        yaxis.push(graphData[0].node.updatedPrice);
                                    }
                                }

	                        }else{
		                        for(var i=0;i<graphData.length;i++){
			                        yaxis[i] =  graphData[i].node.updatedPrice;
			                        xaxis[i] = graphData[i].node.created;
		                        }
	                        }


                            return(
                                <div className={"stock-card"} key={index}>
                                        <div className={"stock-item"}>
                                            <div className={''} onClick={()=> {
	                                            // props.history.push("/stock-detail/" + item.node.id);
	                                            stockRedirectHandler(item.node.id)
                                            }}>
                                                <img src={item.node.politicianImage?item.node.politicianImage:ProfileIcon} alt={"ProfileIcon"} className={"img-fluid stock-profile-pic"}/>
                                                <p className={"stock-name"}>{item.node.name}</p>
                                            </div>
                                            <p className={"stock-price"}>₹ {item.node.price}</p>
                                            <p className={"stock-price-diffrence"}
                                               style={{color:stock_history_details.price_diff_percentage>=0?profit_color:loss_color}}
                                            > {stock_history_details.price_diff_percentage}%
                                            </p>
                                        </div>

                                    {
                                        xaxis.length > 0 &&
                                        <SparklineGraph
                                            curve={"smooth"}
                                            sparkline={true}
                                            color={stock_history_details.price_diff_percentage >= 0 ?profit_color:loss_color}
                                            xaxis={xaxis}
                                            yaxis={yaxis}
                                            graph_filter={"1day"}
                                            graph_loading={false}
                                        />
                                    }

                                </div>
                            );
                        })
                    }
                </OwlCarousel>
                    :
                    <div className={"error-section"}>No Datas Found</div>
            }

        </div>
    );
};
export default withRouter(SimilarStocks);
